const methods = {
  dablena: (d,a,b,l,e,_) => {
    d[b]=d[b]||function(){(d[b].q=d[b].q||[]).push(arguments)};e=a.createElement(l);
    e.async=1;e.charset='utf-8';e.src='//static.dable.io/dist/dablena.min.js';
    _=a.getElementsByTagName(l)[0];_.parentNode.insertBefore(e,_);
  },
  tracking: (type, value) => dablena(type, value)
}

export default {
  install(Vue) {
    methods.dablena(window, document, 'dablena', 'script');
    Vue.prototype.$trackingService = methods.tracking;
  }
}